module.exports = __webpack_public_path__ + "static/media/15_l_kust_0_56.76.c58edddc.png";